
import Access from './access.vue'
import Role from './role.vue'
import User from './user.vue'
import ThirdApp from './thirdApp.vue'
import Config from './config.vue'
import AdminLists from './adminLists.vue'

export default {
	AdminLists,
	Role,
	User,
	Access,
	ThirdApp,
	Config,
  AdminLists
}



// WEBPACK FOOTER //
// ./src/views/user/index.js